export enum ViewType {
  TechnicalConditions = 0,
  Order = 1,
  Assistance = 2,
}
